const productSubscription = () => {
	const paymentButtons = document.querySelectorAll('[data-subscription-button]');
	const sellingPlansInputs = document.querySelectorAll('[data-selling-plan-input]');
	const quantityInput = document.querySelector('.quantity-input');
	const sellingPropInput = document.querySelector('[data-selling-plan-prop]');
	const notice = document.querySelector('[data-selling-notice]');
	const price = document.querySelector('[data-subscription-price]')?.dataset.subscriptionPrice;

	for (const input of sellingPlansInputs) {
		if (input.checked) {
			quantityInput.value = input.dataset.subscriptionQuantity;
			sellingPropInput.value = input.dataset.subscriptionId;
			notice.innerHTML = input.dataset.subscriptionName;
			updateTotalPrice(price, quantityInput.value, input.dataset.subscribeDiscount);
		}
		input.addEventListener('change', (event) => {
			const subscriptionMarker = document.querySelector('[data-subscription-button="false"]');
			if (event.target.checked) {
				quantityInput.value = event.target.dataset.subscriptionQuantity;
				if (subscriptionMarker.classList.contains('active')) {
					sellingPropInput.value = '';
					notice.innerHTML = '';
					updatePrice(event.target.dataset.subscribeDiscount, event.target.dataset.purchaseDiscount, price);
					updateTotalPrice(price, quantityInput.value, event.target.dataset.purchaseDiscount);
				} else {
					sellingPropInput.value = event.target.dataset.subscriptionId;
					notice.innerHTML = event.target.dataset.subscriptionName;
					updatePrice(event.target.dataset.subscribeDiscount, event.target.dataset.purchaseDiscount, price);
					updateTotalPrice(price, quantityInput.value, event.target.dataset.subscribeDiscount);
				}
			}
		})
	}

	for (const button of paymentButtons) {
		button.addEventListener('click', (e) => {
			paymentButtons.forEach((elem) => {{
				elem.classList.remove('active');
			}})
			button.classList.add('active');
			sellingPlansInputs.forEach((input) => {
				if (button.dataset.subscriptionButton === 'false') {
					if (input.checked) {
						quantityInput.value = input.dataset.subscriptionQuantity;
						sellingPropInput.value = '';
						notice.innerHTML = '';
						updateTotalPrice(price, quantityInput.value, input.dataset.purchaseDiscount);
					}
				} else {
					if (input.checked) {
						quantityInput.value = input.dataset.subscriptionQuantity;
						sellingPropInput.value = input.dataset.subscriptionId;
						notice.innerHTML = input.dataset.subscriptionName;
						updateTotalPrice(price, quantityInput.value, input.dataset.subscribeDiscount);
					}
				}
			})
		})

	}
}

const updateTotalPrice = (price, quantity, discount) => {
	const quickBuyButton = document.querySelector('[data-quick-buy-button]');
	const totalPrice = Math.round(price * quantity * (1 - discount / 100) / 100);
	const totalComparePrice = Math.round(price * quantity / 100);

	if (quickBuyButton.querySelector('.price')) {
		changePrice(quickBuyButton.querySelector('.price'), totalPrice);
	}
	if (quickBuyButton.querySelector('.compare-price')) {
		changePrice(quickBuyButton.querySelector('.compare-price'), totalComparePrice);
	}
	if (totalPrice === totalComparePrice) {
		quickBuyButton.querySelector('.compare-price').style.display = 'none';
	} else {
		quickBuyButton.querySelector('.compare-price').style.display = 'inline-block';
	}

}

const changePrice = (container, price) => {
	const currentText = container.textContent.trim();
	const numberRegex = /\d+(\.\d+)?/;
	const newText = currentText.replace(numberRegex, price);
	container.textContent = newText;
}

const updatePrice = (subscribeDiscount, purchaseDiscount, price) => {
	const subscribePriceContainer = document.querySelector('[data-subscription-button="true"] .price');
	const purchasePriceContainer = document.querySelector('[data-subscription-button="false"] .price');
	const subscribeDiscountContainer = document.querySelector('[data-subscription-button="true"] .discount span');
	const purchaseDiscountContainer = document.querySelector('[data-subscription-button="false"] .discount span');
	const subscribePrice = Math.round(price * (1 - subscribeDiscount / 100) / 100);
	const purchasePrice = Math.round(price * (1 - purchaseDiscount / 100) / 100);
	if (subscribePriceContainer) {
		changePrice(subscribePriceContainer, subscribePrice);
	}
	if (purchasePriceContainer) {
		changePrice(purchasePriceContainer, purchasePrice);
	}
	if (subscribeDiscount === '0') {
		subscribeDiscountContainer.parentElement.style.display = 'none';
	} else {
		subscribeDiscountContainer.parentElement.style.display = 'inline-block';
		subscribeDiscountContainer.innerHTML = `${subscribeDiscount}% `
	}

	if (purchaseDiscount === '0') {
		purchaseDiscountContainer.parentElement.style.display = 'none';
	} else {
		purchaseDiscountContainer.parentElement.style.display = 'inline-block';
		purchaseDiscountContainer.innerHTML = `${purchaseDiscount}% `
	}
}

document.addEventListener('DOMContentLoaded', () => {
	productSubscription();
})